import React, { useState, useEffect, Fragment } from 'react'
import ReactDOM from 'react-dom/client'
import moment, { Moment } from "moment"
import Calendar from '../portal/responsive/host/order/calendar'

const DEFAULT_LOCALE = 'en'

/** Main OBS Search component (entrypoint component) */
const ScheduleMapCalendar = ({ dataset }) => {
    const [locale,setLocale]=useState(DEFAULT_LOCALE);

    useEffect(() => {
        let locale = dataset.locale.slice(0, 2).toLowerCase()
        moment.locale(locale)
        setLocale(locale)
        getLocale(locale)
    }, []);

    const format_centered_date = (loc) => {
        let centered_date = moment()
        if (dataset.centered !== "") {
            // Transform centered_date date to moment
            centered_date = moment(dataset.centered, "YYYY-MM-DD")
        }
        return centered_date
    }

    const getLocale = loc => {
        if (loc === 'en') loc = 'en-GB'
        require(`date-fns/locale/${loc}/index.js`)
    }

    const renderCalendar = (centered_date, submit_button, date_field_name) => (
        <Fragment>
            <Calendar
                centered_date={centered_date}
                submit_button={submit_button}
                date_field_name={date_field_name}
            />
        </Fragment>
    )

    try {        
        // *****************************************************
        // centered Date
        let centered_date = format_centered_date(locale)
        let submit_button = dataset.submit_button
        let date_field_name = dataset.date_field_name

        return renderCalendar(centered_date, submit_button, date_field_name)

    } catch (error) {
        console.error(error)

        return (
            <Fragment>
                <ErrorCaption
                    caption="ERROR"
                />
            </Fragment>
        )
    }
}

document.addEventListener('DOMContentLoaded', () => {
    // Embed application component into the DOM when is loaded
    const root = document.getElementById('schedule-map-calendar')
    if (root) {
        const form = ReactDOM.createRoot(root)
        form.render(<ScheduleMapCalendar dataset={root.dataset} />)
    }
})